// BFN Calculator integration config (Phase 3).
//
// Mirrors the aiChatConfig.ts feature-flag pattern. DEFAULT OFF: unless
// VITE_BFN_ENABLED is exactly "true", the navbar button is hidden and the
// calculator view is unreachable — nothing changes for real users until the
// flag is flipped on staging.
export const FLAG_BFN_ENABLED = import.meta.env.VITE_BFN_ENABLED === "true";

// Gateway origin (e.g. https://bfn.staging.orionmessenger.io). Used for the
// /session cookie handshake, the iframe src, and the strict postMessage
// origin check. Normalised to a bare origin (no trailing slash / path) so it
// compares exactly against MessageEvent.origin. Empty when unset or invalid.
const rawBfnUrl = import.meta.env.VITE_BFN_URL ?? "";

export const BFN_URL = safeHttpOrigin(rawBfnUrl);

// The feature is only AVAILABLE when it is both enabled AND a valid absolute
// http(s) gateway origin is configured. This is a FAIL-CLOSED gate: a missing
// or malformed VITE_BFN_URL disables the feature entirely rather than letting
// the handshake fall back to a same-origin relative `POST /session` — which
// would leak the bfn token to the OA app's own origin and load an empty/
// recursive iframe. The button/view must gate on this, never on
// FLAG_BFN_ENABLED alone.
export const BFN_AVAILABLE = FLAG_BFN_ENABLED && BFN_URL !== "";

if (FLAG_BFN_ENABLED && BFN_URL === "") {
  // eslint-disable-next-line no-console
  console.warn(
    "[bfn] VITE_BFN_ENABLED is true but VITE_BFN_URL is missing or not a " +
      "valid absolute http(s) origin — the BFN Calculator is disabled.",
  );
}

function safeHttpOrigin(url: string): string {
  if (!url) {
    return "";
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return "";
    }
    return parsed.origin;
  } catch {
    return "";
  }
}
